import { render, staticRenderFns } from "./primary_inspection_edit.vue?vue&type=template&id=4bada69f&scoped=true&"
import script from "./primary_inspection_edit.vue?vue&type=script&lang=js&"
export * from "./primary_inspection_edit.vue?vue&type=script&lang=js&"
import style0 from "./primary_inspection_edit.vue?vue&type=style&index=0&id=4bada69f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bada69f",
  null
  
)

export default component.exports